// extracted by mini-css-extract-plugin
export default {"paymentsBrand":"styles_paymentsBrand__JyXQF"};